const en = {
  // Common
  save: 'Save',
  cancel: 'Cancel',
  delete: 'Delete',
  edit: 'Edit',
  close: 'Close',
  loading: 'Loading...',
  saving: 'Saving...',
  
  // Auth
  login: 'Log in',
  logout: 'Log out',
  register: 'Sign up',
  email: 'Email',
  password: 'Password',
  name: 'Name',
  loginSubtitle: 'Log in to continue to FlowFocus',
  registerSubtitle: 'Get started with FlowFocus today',
  noAccount: 'No account?',
  hasAccount: 'Already have an account?',
  createAccount: 'Sign up',
  
  // Sidebar
  all: 'All',
  inbox: 'Inbox',
  today: 'Today',
  starred: 'Starred',
  done: 'Done',
  admin: 'Admin',
  helpGuide: 'Help & Guide',
  upgradePro: 'Upgrade to Pro',
  quickStats: 'Quick Stats',
  total: 'Total',
  inProgress: 'In Progress',
  doneToday: 'Done today',
  personal: 'Personal',
  shared: 'Shared',
  
  // Dashboard
  allTasks: 'All tasks',
  todayTasks: 'Today',
  starredTasks: 'Starred',
  doneTasks: 'Done',
  inboxTasks: 'Inbox',
  tasks: 'tasks',
  of: 'of',
  
  // Quick Capture
  quickCapturePlaceholder: 'Dump a task... press Enter',
  
  // Today Focus
  todayFocus: 'Today\'s Focus',
  noFocusTasks: 'No focus tasks selected. Click the star on a task to add it here.',
  
  // Kanban
  nextUp: 'Next Up',
  dragHere: 'Drag tasks here',
  
  // Task
  priority: 'Priority',
  low: 'Low',
  medium: 'Medium',
  high: 'High',
  tag: 'Tag',
  noTag: 'No tag',
  description: 'Description',
  createdAt: 'Created',
  createdBy: 'Created by',
  
  // Workspace Settings
  workspaceSettings: 'Workspace Settings',
  workspaceName: 'Workspace name',
  workspaceIcon: 'Workspace icon',
  members: 'Members',
  owner: 'Owner',
  member: 'Member',
  inviteMember: 'Invite member',
  invite: 'Invite',
  
  // Workspace Info
  workspaceInfo: 'Workspace Info',
  noInfoYet: 'No info yet',
  addInfoDesc: 'Add links, passwords and notes for this workspace',
  addField: 'Add field',
  website: 'Website',
  testEnv: 'Test environment',
  passwordField: 'Password',
  emailField: 'Email',
  note: 'Note',
  infoSaved: 'Info saved',
  
  // Profile
  editProfile: 'Edit profile',
  roleTitle: 'Role / Title',
  rolePlaceholder: 'e.g. Project Manager, CEO, Developer',
  showsBelowName: 'Shown below your name in the sidebar',
  emailCantChange: 'Email cannot be changed',
  clickToChangeAvatar: 'Click to change profile picture',
  profileUpdated: 'Profile updated',
  imageMaxSize: 'Image max size is 2 MB',
  avatarUpdated: 'Profile picture updated',
  
  // Filters
  manageTags: 'Manage tags',
  allFilter: 'All',
  
  // AI
  aiAssistant: 'FlowFocus AI',
  aiLocked: 'AI assistant requires Pro',
  aiLockedDesc: 'Get help breaking down tasks, prioritizing and planning your day with GPT-5.2.',
  aiPlaceholder: 'Ask me about your tasks...',
  aiGreeting: 'Hi! I can help you with your tasks.',
  planMyDay: 'Plan my day',
  prioritizeTasks: 'Prioritize tasks',
  breakdownTask: 'Break down a task',
  
  // Upgrade
  upgradeTitle: 'Upgrade to Pro',
  alreadyPro: 'You already have the Pro plan!',
  upgradeBtn: 'Upgrade to Pro — 199 SEK/mo',
  perMonth: '/mo',
  popular: 'POPULAR',
  free: 'Free',
  pro: 'Pro',
  freeDesc: 'Perfect to get started',
  proDesc: 'For those serious about productivity',
  
  // Free features
  feat1Workspace: '1 workspace',
  feat2Invites: '2 invitations',
  featKanban: 'Kanban board with drag & drop',
  featQuickCapture: 'Quick Capture',
  featTags: 'Tags & filters',
  featFocus: 'Today\'s focus',
  
  // Pro features
  featUnlimitedWs: 'Unlimited workspaces',
  featUnlimitedInv: 'Unlimited invitations',
  featAI: 'AI assistant (GPT-5.2)',
  featBreakdown: 'Task breakdown & prioritization',
  featPlanning: 'Daily planning help',
  featAllFree: 'Everything in Free',
  
  // Help Guide
  helpTitle: 'How FlowFocus works',
  helpIntro: 'FlowFocus helps you',
  helpCapture: 'capture ideas quickly',
  helpOrganize: 'organize them visually',
  helpFocus: 'focus on what matters most',
  
  // Onboarding
  step: 'Step',
  onboardingOf: 'of',
  next: 'Next',
  done_btn: 'Done!',
  onb1Title: 'Dump everything from your head',
  onb1Desc: 'Write a thought, task or idea and press Enter. It goes straight to Inbox. Sort later.',
  onb2Title: 'Drag & organize',
  onb2Desc: 'Drag tasks between columns: Inbox → Next Up → In Progress → Done. See your progress visually.',
  onb3Title: 'Focus on the right things',
  onb3Desc: 'Star the most important. Pick max 3 focus tasks per day. Less overwhelm, more doing.',
  
  // Landing Page
  landingTagline: 'Designed for focus & flow',
  landingH1_1: 'Task manager for',
  landingH1_2: ' brains with many ideas',
  landingSubtitle: 'Capture thoughts quickly. Organize visually. Focus on what matters. FlowFocus helps you go from overwhelmed to in control.',
  startFree: 'Start free',
  seePricing: 'See pricing',
  benefit1: 'Reduce mental overwhelm',
  benefit2: 'Go from thinking to doing',
  benefit3: 'Keep track of multiple projects',
  benefit4: 'Perfect for ADHD brains',
  benefit5: 'Collaborate without chaos',
  featuresTitle: 'Everything you need to stay focused',
  featuresSubtitle: 'Simple tools that work together to help you execute',
  howTitle: 'How it works',
  step1: 'Dump',
  step1Desc: 'Write everything that comes to mind. Press Enter.',
  step2: 'Organize',
  step2Desc: 'Drag to the right column. Add tags.',
  step3: 'Focus',
  step3Desc: 'Pick today\'s 3 most important. Star them.',
  step4: 'Execute',
  step4Desc: 'Do. Drag to Done. Repeat.',
  pricingTitle: 'Simple pricing',
  pricingSubtitle: 'Start free. Upgrade when you need more.',
  startWithPro: 'Start with Pro',
  ctaTitle: 'Ready to take control?',
  ctaSubtitle: 'Start free. No credit card. Upgrade when you want.',
  createAccountFree: 'Create free account',
  pricing: 'Pricing',
  
  // Feature cards
  featCaptureTitle: 'Quick Capture',
  featCaptureDesc: 'Dump thoughts instantly. Press Enter and it lands in Inbox. Sort later.',
  featKanbanTitle: 'Visual Kanban Flow',
  featKanbanDesc: 'Drag tasks between Inbox, Next Up, In Progress and Done.',
  featFocusTitle: 'Focus on the right things',
  featFocusDesc: 'Star important tasks. Pick 3 focus tasks for the day.',
  featCollabTitle: 'Easy collaboration',
  featCollabDesc: 'Invite team members to workspaces. See who created what.',
  featTrackTitle: 'Track over time',
  featTrackDesc: 'See when tasks were created. Filter by time, priority, tags.',
  featAITitle: 'AI Assistant',
  featAIDesc: 'Break down tasks, get prioritization help and daily planning with GPT-5.2.',
  
  // Invite page
  inviteTitle: 'Workspace Invitation',
  inviteAccepting: 'Accepting invitation...',
  inviteSuccess: 'You\'ve joined the workspace!',
  inviteGoToDashboard: 'Go to Dashboard',
  inviteLoginFirst: 'Log in to accept the invitation',
};

export default en;
